import React from 'react';

import utils               from '../../../../../../../../utils';
import Context             from '../../../../../../../../context';
import Cookies             from 'js-cookie';
import constants           from '../../../../../../../../values/constants';
import WithdrawalComponent from '../../../../components';

import { useTranslation    } from 'react-i18next';
import { WITHDRAWAL_STATUS } from '../../../../../../../../values/dropdownItems';
import {
  CustomIcon     ,
  CustomBadges   ,
  TableNullData  ,
  UserInformation,
} from '../../../../../../../../components';

import './index.sass';

type Props = {
  data: any;
};

const Body: React.FC<Props> = ({ data }: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const {
    setShowModal,
    requestWithdrawal,
    selectedWithdrawals,
    setSelectedWithdrawal,
    setSelectedWithdrawals,
  } = React.useContext(Context.WithdrawalScreen);
  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result?.docs;
  const { t } = useTranslation();
  const userType = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickInfo(): void {
    setOpenInfoModal(!openInfoModal);
  }

  function checkHandler(_id: string): void {
    let newFactorList: string[] = [...selectedWithdrawals];
    if (selectedWithdrawals?.find((item: string) => item === _id)) {
      newFactorList = selectedWithdrawals.filter((item: string) => item !== _id);
    } else {
      newFactorList = [...selectedWithdrawals, _id];
    }
    setSelectedWithdrawals(newFactorList);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="withdrawal-admin-container">
      {docs?.map((withdrawal: any, index: number) => {
        let withdrawalInfo: any = {};
        withdrawalInfo = withdrawal?.userId;
        return (
          <tr key={`files-tr-${index}`} onClick={() => checkHandler(withdrawal?._id)}>
            <td onClick={onClickInfo}>
              <div className="table-index-number">
                {requestWithdrawal?.page === 1 ? index + 1 : (requestWithdrawal?.page - 1) * 10 + index + 1}
              </div>
            </td>
            <td>
              <input
                id="checkmark"
                type="checkbox"
                name="checkmark"
                checked={!!selectedWithdrawals?.find((item: string) => item === withdrawal._id)}
              />
            </td>
            <td onClick={onClickInfo}>
              <UserInformation
                name       = { withdrawalInfo?.firstName   }
                avatar     = { withdrawalInfo?.avatar      }
                lastName   = { withdrawalInfo?.lastName    }
                phoneNumber= { withdrawalInfo?.phoneNumber }
              />
            </td>
            <td onClick={onClickInfo}>{utils.convertNumberToPrice(withdrawal?.amount)}{t("toman")}</td>
            <td>{"IR" + withdrawal?.shabaId}</td>
            <td>{t(withdrawal?.bankName)}</td>
            <td>
              <CustomBadges
                title={t(
                  WITHDRAWAL_STATUS.find(
                    (item) => item.value === withdrawal?.status
                  )?.name as string
                )}
                type={
                  withdrawal?.status === "REJECT" ?
                    "danger" : withdrawal?.status === "SUCCESS" ?
                      "success" : withdrawal?.status === 'SEND2BANK' ?
                        'primary' : "warning"
                }
              />
            </td>
            <td onClick={onClickInfo}>
              <div className="approve-icons">
                {withdrawal?.status === "PENDING" && userType === "ADMIN" && (
                  <>
                    <CustomIcon
                      hoverTitle={t("approve")}
                      icon="fas fa-check"
                      type='success'
                      onClick={() => {
                        setShowModal("APPROVE");
                        setSelectedWithdrawal(withdrawal);
                      }}
                    />
                    <CustomIcon
                      hoverTitle='ارسال به بانک'
                      icon="fa-solid fa-school"
                      type='primary'
                      onClick={() => {
                        setShowModal("SEND_2_BANK");
                        setSelectedWithdrawal(withdrawal);
                      }}
                    />
                    <CustomIcon
                      hoverTitle={t("reject")}
                      icon="fas fa-xmark"
                      type='danger'
                      onClick={() => {
                        setShowModal("DIS_APPROVE");
                        setSelectedWithdrawal(withdrawal);
                      }}
                    />
                  </>
                )}
              </div>
            </td>
          </tr>
        );
      })}
      </tbody>
      <WithdrawalComponent.Approve    role="ADMIN" />
      <WithdrawalComponent.Send2Bank  role="ADMIN" />
      <WithdrawalComponent.DisApprove role="ADMIN" />
    </>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Body;
